import customHeaders, { getSpace } from '../../common/headers';
import scan_icon from './img/scan_icon.svg';
import print_icon from './img/print_icon.svg';
import arhive_icon from './img/archive_icon.svg';
import { useNavigate, useParams } from 'react-router-dom';
import { useDataTable } from '../../common/hooks';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { fetchOrdersFilterNew } from '../../common/filtersFunc';
import { useState, useEffect, useRef } from 'react';
import { ModalTableActions } from '../../components/Modal/ModalTableActions/ModalTableActions';
import { ArtemOrdersHttps, ArtemOrdersHttp } from '../../fetchUrls';
import { ModalAlert } from '../../components/Modal/ModalAlert/ModalAlert';
import {
  DropDownSelector,
  TableBox,
  Tabs,
  RangeBox,
  ButtonBasic,
} from '@lk-gtcom/ecomlab-components';
import useGeneralStore from '../../store/general';
import './OrderManagement.scss';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { ButtonWithIcon } from '../../components/Buttons/ButtonWithIcon/ButtonWithIcon';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { RequestController } from '../../common/filtersFunc';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { msToLocalDate } from '../../common/constant';
import { ModalOrderStatus } from './ModalOrderStatus/ModalOrderStatus';
import { options_prop_mp } from '../../common/globalVariables';
import { ModalLabelPrinting } from './ModalLabelPrinting/ModalLabelPrinting';
import { useResponseHandler } from '../../common/auth';
import { usePushNotifications } from '../../common/pushNotification';
import { ModalCollectOrders } from './ModalCollectOrders/ModalCollectOrders';

const OrderManagement = () => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const requestControllerRef = useRef(new RequestController());
  const { handleTableResponse, handleRequestError } = useResponseHandler();
  const { addErrorPush, addSuccessPush } = usePushNotifications();

  // Фильтры
  const filterConfig = [
    { key: 'mp', type: 'multi' },
    { key: 'api', type: 'multi' },
    { key: 'category', type: 'multi' },
    { key: 'brand', type: 'multi' },
    { key: 'warehouse', type: 'multi' },
    { key: 'date_from', type: 'single' },
    { key: 'date_to', type: 'single' }
  ];
  const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
  const [isFilterRequest, setIsFilterRequest] = useState(false);

  // Флаг для отслеживания первой инициализации из URL
  const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

  const [date, setDate] = useState(() => {
    const now = new Date();
    const endOfDay = new Date(now);
    endOfDay.setHours(23, 59, 59, 999);

    const startOfDay = new Date(now);
    startOfDay.setDate(startOfDay.getDate() - 6); // -6 чтобы получить 10 число
    startOfDay.setHours(0, 0, 0, 0);

    return [startOfDay.getTime(), endOfDay.getTime()];
  });
  const [dateFrom, dateTo] = date;
  const navigate = useNavigate();

  const activeTab = useParams()['*'];
  const [pageValue, setPageValue] = useState(null);

  const [apiPage, setApiPage] = useState(1);
  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);
  const [warehousePage, setWarehousePage] = useState(1);

  const [apiQuery, setApiQuery] = useState('');
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');
  const [warehouseQuery, setWarehouseQuery] = useState('');

  const [apiData, setApiData] = useState([]);
  const [warehouseData, setWarehouseData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);

  const [selectedMarketplace, setSelectedMarketplace] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedApi, setSelectedApi] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedWarehouse, setSelectedWarehouse] = useState([{ label: 'Все', value: 'all' }]);

  const [totalApi, setTotalApi] = useState(0);
  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0)
  const [totalWarehouse, setTotalWarehouse] = useState(0);

  const [isModalAlert, setIsModalAlert] = useState(false)

  // таблица
  const [isTableRequest, setIsTableRequest] = useState(false);
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoading, setFetchedData, setHeaders, setSort, setFilters } = setTableFuncs;
  const [checkedProducts, setCheckedProducts] = useState([]);

  const [tabs, setTabs] = useState([]);
  const [dateList, setDateList] = useState([]);

  const [availableActions, setAvailableActions] = useState([])

  // Modal
  const [isModalLabelPrint, setIsModalLabelPrint] = useState(false);
  const [isModalOrderStatus, setIsModalOrderStatus] = useState(false);
  const [isModalCollectOrders, setIsModalCollectOrders] = useState(false);
  const [currentCard, setCurrentCard] = useState('all');
  const [contextMenuArr, setContextMenuArr] = useState([]);
  const [isModalTable, setIsModalTable] = useState(false);
  const [isResetChecxbox, setIsResetCheckbox] = useState(false)
  const [loadingTabs, setLoadingTabs] = useState(false)
  const [loadingCards, setLoadingCards] = useState(false)

  const [isTabsRequest, setIsTabsRequest] = useState(false)

  const resetTable = () => {
    paginatorRef.current.reset();
    paginatorRef.current.setTotal(0);
    setSort({});
    setHeaders([]);
    setFetchedData([]);
  };

  // Инициализация фильтров из URL параметров при первом рендере
  useEffect(() => {
    if (!isInitialLoadFromURL) {
      setIsInitialLoadFromURL(true);

      // Обновляем все состояния фильтров
      setTimeout(() => {
        if (urlParams.mp) setSelectedMarketplace(urlParams.mp);
        if (urlParams.api) setSelectedApi(urlParams.api);
        if (urlParams.category) setSelectedCategory(urlParams.category);
        if (urlParams.brand) setSelectedBrand(urlParams.brand);
        if (urlParams.warehouse) setSelectedBrand(urlParams.warehouse);
        // if (urlParams.dateFrom) setDateFrom(urlParams.dateFrom);
        // if (urlParams.dateTo) setDateTo(urlParams.dateTo);
        // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
        setIsFilterRequest(prev => !prev);
        if (Object.keys(urlParams).length > 0) {
          setIsTableRequest(prev => !prev);
        }
      }, 10);
    }
  }, [urlParams]);

  useEffect(() => {
    const curr = tabs?.filter((el) => el?.value === pageValue)
    if (curr?.[0] && curr?.[0]?.available_actions?.length) {
      setAvailableActions(curr?.[0]?.available_actions)
    }
  }, [pageValue]);

  const btn_table = [
    {
      label: 'Сбросить все', onClick: (e) => {
        setIsResetCheckbox(!isResetChecxbox)
      }
    }
  ];

  // Отменить заказы.

  useEffect(() => {
    setCurrentCard(null);
  }, [date]);

  // Таблица
  const fetchTableData = (params, abortController = new AbortController()) => {

    if (!tabs?.length || !pageValue) {
      resetTable()
      setLoading(false)
      return;
    }

    setLoading(true)
    let sort;
    let filters;

    if (params) {
      [sort, filters] = params;
    }

    let url = `https://apps0.ecomru.ru:4449/v1/orders/table?table_filter=${pageValue}${sort?.length > 0
      ? '&order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''}`;
    let date_from = null;
    let date_to = null;

    if (currentCard && currentCard != 'all') {
      date_from = msToLocalDate(date[0])
      date_to = msToLocalDate(date[1])
    } else {
      if (Array.isArray(date) && date?.length > 0) {
        date_from = msToLocalDate(date[0])
        date_to = msToLocalDate(date[1])
      }
    }
    if (currentCard && currentCard == 'all') {
      date_from = null;
      date_to = null;
    }

    const body = JSON.stringify({
      mp_id_list: getValueMultiFilter(selectedMarketplace),
      api_id_list: getValueMultiFilter(selectedApi),
      brand_id_list: getValueMultiFilter(selectedBrand),
      category_id_list: getValueMultiFilter(selectedBrand),
      warehouse_id_list: getValueMultiFilter(selectedWarehouse),
      filters,
      date_from,
      date_to,
      page: paginatorRef.current.page,
      limit: paginatorRef.current.limit,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((table) => {
        const { contextMenuArr } = table;
        if (contextMenuArr?.length > 0) {
          contextMenuArr[0].onClick = onDeleteAccountHandler;
          setContextMenuArr(contextMenuArr);
        }
        setTable(table);
      })
      .catch(handleRequestError)
      .finally(() => {
        if (abortController.signal.aborted) return
        setLoading(false)
      })
  };

  // Скачать этикетку
  const fetchPrintLabel = (api_id, mp_id, posting_number, offer_id) => {
    const url = 'https://apps0.ecomru.ru:4449/v1/orders/package-label/print';

    const body = JSON.stringify({
      api_id,
      mp_id,
      posting_number,
      offer_id
    })

    fetch(url, { method: 'POST', headers, body })
      .then(response => {
        if (response.status === 400) {
          // Обработка ошибки 400

          return response.json().then(data => {
            addErrorPush(data?.detail)
            throw { status: 400, data };
          });
        }
        return response.blob();
      })
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Наклейка_${posting_number}.pdf`
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch(handleRequestError)
  };

  const onDeleteAccountHandler = (e) => {
    const numberPosting = {
      api_id: e?.api_id,
      id: e?.['Номер отправления'][0],
      mp_id: e.mp_id
    };
    fetchСancelOrders([numberPosting]);
    setIsTableRequest(!isTableRequest)
  };

  // Табы
  const fetchTabs = (counterOnly = false, abortController = new AbortController()) => {
    if (!counterOnly) {
      setLoadingTabs(true);
    }
    let url = `https://apps0.ecomru.ru:4449/v1/orders/status-tabs`;

    const body = JSON.stringify({
      mp_id_list: getValueMultiFilter(selectedMarketplace),
      api_id_list: getValueMultiFilter(selectedApi),
      brand_id_list: getValueMultiFilter(selectedBrand),
      category_id_list: getValueMultiFilter(selectedCategory),
      warehouse_id_list: getValueMultiFilter(selectedWarehouse),
      date_from: msToLocalDate(date[0]),
      date_to: msToLocalDate(date[1]),
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then(({ tabs }) => {
        const tabs_list = tabs.map(({ name, id, count, available_actions }) => ({
          label: name,
          value: id,
          counter: count,
          available_actions
        }));
        setTabs(tabs_list);
        if (!counterOnly) {
          if (tabs_list?.[0]?.value) {
            navigate(`/order-management/${tabs_list?.[0]?.value}${window.location.search}`, { replace: true });
            setPageValue(tabs_list?.[0]?.value)
          }
        }
        setIsTableRequest(!isTableRequest)
      })
      .catch(handleRequestError)
      .finally(() => {
        setLoadingTabs(false);
        if (abortController?.signal?.aborted) return;
      });
  };

  // Упаковать заказы
  const fetchPackOrders = (order_ids) => {
    if (selectedApi?.value == 'all') {
      setIsModalAlert('Выберите магзин');
      return;
    }

    let url = `${ArtemOrdersHttps}/orders/pack-orders`;

    const body = JSON.stringify({
      orders: order_ids

    });

    fetch(url, { body, method: 'POST', headers })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw new Error(JSON.stringify(err));
        }
      })
      .then(({ options }) => {
        // fetchTabs(true);
        setIsTableRequest(!isTableRequest)
        setCheckedProducts([])
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setLoading(false));
  };

  // Отменить заказы
  // Работает
  // куда попадают отмененные заказы
  // причины отмены как выводить
  const fetchСancelOrders = (order_ids) => {
    if (selectedApi?.value == 'all') {
      setIsModalAlert('Выберите магзин');
      return;
    }

    let url = `${ArtemOrdersHttps}/orders/cancel-orders?filter_type=${selectedMarketplace?.value}`;

    let api_id;

    if (selectedApi?.value) {
      api_id = selectedApi?.value;
    }

    const body = JSON.stringify({
      api_id: api_id,
      msg: 'Товар закончился',
      orders: order_ids,
      reason_id: 352,
    });

    fetch(url, { body, method: 'POST', headers })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw new Error(JSON.stringify(err));
        }
      })
      .then(({ options }) => {
        // fetchTabs();
        setIsTableRequest(!isTableRequest)
        setCheckedProducts([])
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setLoading(false));
  };

  // Наклейки
  const fetchLabels = (order_ids) => {
    if (selectedApi?.value == 'all') {
      setIsModalAlert('Выберите магзин');
      return;
    }

    let url = `${ArtemOrdersHttps}/orders/get-order-labels`;

    let api_id;

    if (selectedApi?.value) {
      api_id = selectedApi?.value;
    }

    const body = JSON.stringify({
      api_id: api_id,
      orders: order_ids,
    });

    fetch(url, { body, method: 'POST', headers })
      .then(async (res) => {
        if (res.ok) {
          return res.arrayBuffer()
        } else {
          const err = await res.json()
          throw new Error(JSON.stringify(err?.detail))
        }
      })
      .then((body) => {
        // setLoaderExcel(false)
        const date = new Date();
        const fileName = `orders ${date.toLocaleDateString('ru-RU', {
          dateStyle: 'short',
        })} ${date.toLocaleTimeString('ru-RU', { timeStyle: 'short' })}.pdf`;
        const blob = new Blob([body]);

        if (navigator.msSaveBlob) {
          // IE 10+
          navigator.msSaveBlob(blob, fileName);
        } else {
          const link = document.createElement('a');
          // Browsers that support HTML5 download attribute
          if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', fileName);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
        setCheckedProducts([])
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setLoading(false));
  };

  const onActionHandler = (e) => {

    const numberPosting = {
      api_id: e?.api_id,
      id: e?.['Номер отправления'][0],
      mp_id: e.mp_id,
      campaign_id: e.campaign_id
    };

    const api_id = e?.api_id;
    const mp_id = e?.mp_id;
    const offer_id = e?.['Артикул'][4];
    const posting_number = e?.['Номер отправления']

    if (e?.['Распечатать']) {
      // fetchLabels(api_id, mp_id, posting_number, offer_id);
      // fetchPrintLabel(api_id, mp_id, posting_number, offer_id);
    }
    if (e?.['Этикетка']) {
      fetchPrintLabel(api_id, mp_id, posting_number, offer_id);
      // fetchPackOrders([numberPosting]);
    }
  };

  const apiFilter = () => {
    const controller = requestControllerRef.current.createController('api');

    fetchOrdersFilterNew({
      controller,
      selectedSpace: selectedSpace?.value,
      page: apiPage,
      set: (e) => setApiData(e),
      searchParam: apiQuery,
      selectedMarketplace,
      selectedBrand,
      selectedWarehouse,
      selectedCategory,
      dateFrom,
      dateTo,
      filter: 'order_api_ids ',
      setTotal: setTotalApi
    })?.finally(() => {
      requestControllerRef.current.removeController('api');
    })
  }

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    apiFilter()
  }, [isFilterRequest, apiPage, apiQuery, date]);

  const warehouseFilter = () => {
    const controller = requestControllerRef.current.createController('warehouse');

    fetchOrdersFilterNew({
      controller,
      selectedSpace: selectedSpace?.value,
      page: warehousePage,
      set: (e) => setWarehouseData(e),
      searchParam: warehouseQuery,
      selectedApi,
      selectedMarketplace,
      selectedBrand,
      selectedCategory,
      dateFrom,
      dateTo,
      filter: 'order_warehouse_ids',
      setTotal: setTotalWarehouse
    })?.finally(() => {
      requestControllerRef.current.removeController('warehouse');
    })
  }

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    warehouseFilter()
  }, [isFilterRequest, warehousePage, warehouseQuery, date]);

  const categoryFilter = () => {
    const controller = requestControllerRef.current.createController('category');

    fetchOrdersFilterNew({
      controller,
      selectedSpace: selectedSpace?.value,
      page: categoryPage,
      set: (e) => setCategoryData(e),
      searchParam: categoryQuery,
      selectedApi,
      selectedMarketplace,
      selectedBrand,
      selectedWarehouse,
      dateFrom,
      dateTo,
      filter: 'order_category_ids',
      setTotal: setTotalCategory
    })?.finally(() => {
      requestControllerRef.current.removeController('category');
    })
  }

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    categoryFilter()
  }, [isFilterRequest, categoryPage, categoryQuery, date]);

  const brandFilter = () => {
    const controller = requestControllerRef.current.createController('brand');

    fetchOrdersFilterNew({
      controller,
      selectedSpace: selectedSpace?.value,
      page: brandPage,
      set: (e) => setBrandData(e),
      searchParam: brandQuery,
      selectedApi,
      selectedMarketplace,
      selectedWarehouse,
      selectedCategory,
      dateFrom,
      dateTo,
      filter: 'order_brand_ids',
      setTotal: setTotalBrand
    })?.finally(() => {
      requestControllerRef.current.removeController('brand');
    })
  }

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    brandFilter()
  }, [isFilterRequest, brandPage, brandQuery, date]);

  useEffect(() => {
    paginatorRef.current.reset()
    paginatorRef.current.setTotal(0)
  }, [pageValue]);

  useEffect(() => {
    const abortController = new AbortController();
    // fetchDates(false, abortController)
    return () => abortController.abort();
  }, [pageValue]);

  useEffect(() => {
    const abortController = new AbortController();
    fetchTableData([], abortController);
    return () => abortController.abort();
  }, [
    // currentCard,
    pageValue,
    isTableRequest
  ]);



  useEffect(() => {
    const abortController = new AbortController();
    fetchTabs(false, abortController)
    return () => abortController.abort();
  }, [date, isTabsRequest]);

  useEffect(() => {
    setIsModalTable((checkedProducts?.length > 0) ? true : false);
  }, [checkedProducts]);

  return (
    <>
      {/* Отменить заказы */}

      {isModalOrderStatus && <ModalOrderStatus
        checkedItems={checkedProducts}
        setIsModal={setIsModalOrderStatus}
      />}

      {/* Собрать заказы */}

      {isModalCollectOrders && <ModalCollectOrders
        checkedItems={checkedProducts}
        setIsModal={setIsModalCollectOrders}
      />}

      {/* Печать этикеток */}

      {isModalLabelPrint && <ModalLabelPrinting
        checkedItems={checkedProducts}
        setIsModal={setIsModalLabelPrint}
        status={availableActions}
      />}

      {isModalTable &&
        <ModalTableActions
          products={checkedProducts}
          btns={btn_table}
          setIsModal={(e) => setIsModalTable(e)}
        />
      }

      {isModalAlert &&
        <ModalAlert
          title='Выберите магазин'
          setIsModal={(e) => setIsModalAlert(e)}
        />
      }

      <div className="order-management">
        <TitlePage
          title='Заказы'
        />

        <div className="order-management__filters">
          <FilterContainer
            onReset={(e) => {
              setSelectedMarketplace([])
              setSelectedApi([]);
              setSelectedCategory([]);
              setSelectedBrand([]);
              setSelectedWarehouse([]);
              updateURL({
                mp: null,
                api: null,
                warehouse: null,
                category: null,
                brand: null,
              });
              setIsTabsRequest(!isTabsRequest)
              setIsFilterRequest(!isFilterRequest);
              setIsTableRequest(!isTableRequest)
            }}
          >
            <DropDownSelector
              options_prop={options_prop_mp}
              state={selectedMarketplace}
              setState={setSelectedMarketplace}
              placeholder="Площадка"
              total={options_prop_mp?.length}
              multi
              onBlur={e => {
                updateURL({ mp: selectedMarketplace });
                apiFilter()
                brandFilter()
                categoryFilter()
                warehouseFilter()
                setIsTabsRequest(!isTabsRequest)
                setIsTableRequest(!isTableRequest)
              }}
            />

            <DropDownSelector
              options_prop={apiData}
              state={selectedApi}
              setState={setSelectedApi}
              placeholder="Магазин"
              total={totalApi}
              multi
              fetchCallback={setApiPage}
              setInputChange={setApiQuery}
              onBlur={e => {
                updateURL({ api: selectedApi });
                brandFilter()
                categoryFilter()
                warehouseFilter()
                setIsTabsRequest(!isTabsRequest)
                setIsTableRequest(!isTableRequest)
              }}
            />

            <DropDownSelector
              options_prop={warehouseData}
              state={selectedWarehouse}
              setState={setSelectedWarehouse}
              placeholder="Склад"
              total={totalWarehouse}
              multi
              fetchCallback={setWarehousePage}
              setInputChange={setWarehouseQuery}
              onBlur={e => {
                updateURL({ warehouse: selectedWarehouse });
                brandFilter()
                categoryFilter()
                setIsTabsRequest(!isTabsRequest)
                setIsTableRequest(!isTableRequest)
              }}
            />

            <DropDownSelector
              options_prop={categoryData}
              state={selectedCategory}
              setState={setSelectedCategory}
              placeholder="Категория"
              total={totalCategory}
              multi
              fetchCallback={setCategoryPage}
              setInputChange={setCategoryQuery}
              onBlur={e => {
                updateURL({ category: selectedCategory });
                brandFilter()
                setIsTabsRequest(!isTabsRequest)
                setIsTableRequest(!isTableRequest)
              }}
            />

            <DropDownSelector
              options_prop={brandData}
              state={selectedBrand}
              setState={setSelectedBrand}
              placeholder="Бренд"
              total={totalBrand}
              multi
              fetchCallback={setBrandPage}
              setInputChange={setBrandQuery}
              onBlur={e => {
                updateURL({ brand: selectedBrand });
                setIsTabsRequest(!isTabsRequest)
                setIsTableRequest(!isTableRequest)
              }}
            />
          </FilterContainer>

          <RangeBox
            date={date}
            setDate={setDate}
            btn_period={true}
          />
        </div>

        {tabs?.length ?
          <Tabs
            tabs={tabs}
            pageValue={pageValue}
            setPageValue={setPageValue}
            loading={loadingTabs}
          /> : null}

        {/* {(pageValue == 'awaiting-packaging' || pageValue == 'awaiting-deliver') && <div className="toolbar-medium">
          <div className="card-group">
            {dateList?.length > 0
              ? dateList?.map((props, ind) => {
                const { date, count, less12, expire } = props;
                return (
                  <CardOrder
                    {...props}
                    loading={loadingCards}
                    key={JSON.stringify(props) + '-' + ind}
                    currentCard={currentCard}
                    setCurrentCard={setCurrentCard}
                  />
                );
              })
              : [...Array(4)].map((el, ind) => {
                return (
                  <CardOrder
                    loading={loadingCards}
                    date={false}
                    count={0}
                    key={ind}
                    less12={0}
                    expire={0}
                    currentCard={currentCard}
                    setCurrentCard={setCurrentCard}
                  />
                );
              })}
          </div>


        </div>} */}

        <TableBox
          {...tableProps}
          ref={paginatorRef}
          paginator={true}
          fetchCallback={fetchTableData}
          contextMenuArr={contextMenuArr}
          onCheck={(e) => setCheckedProducts(e)}
          onAction={(e) => onActionHandler(e)}
          onUncheckAllDependence={[pageValue, date, isResetChecxbox]}
          child={
            <>
              <ButtonWithIcon
                whiteGreen
                label='Сканировать'
                icon={scan_icon}
              />

              <ButtonWithIcon
                whiteGreen
                label='Выгрузить заказы'
                icon={arhive_icon}
              />

              <ButtonWithIcon
                whiteGreen
                label='Распечатать лист подбора'
                icon={print_icon}
              />

              <ButtonBasic
                blue
                size="32px"
                text="Собрать заказы"
                disabled={checkedProducts?.length < 1}
                width="fit-content"
                onClick={(e) => setIsModalCollectOrders(true)}
              />

              <ButtonBasic
                red
                size="32px"
                text="Отменить заказы"
                disabled={checkedProducts?.length < 1}
                width="fit-content"
                onClick={(e) => setIsModalOrderStatus(true)}
              />

              <ButtonBasic
                whiteBlue
                size="32px"
                text="Настройки для печати этикеток"
                width="fit-content"
                onClick={(e) => {
                  setIsModalLabelPrint(true)
                }}
              />

              <div className="group-right">
                {activeTab === 'awaiting-packaging' && (
                  <ButtonBasic
                    action
                    size="32px"
                    text="Упаковать"
                    disabled={checkedProducts?.length < 1}
                    width="fit-content"
                    onClick={(e) => {
                      const numberPosting = checkedProducts.map(el => {
                        return {
                          api_id: el?.api_id,
                          id: el?.['Номер отправления'][0],
                          mp_id: el.mp_id,
                          campaign_id: el.campaign_id
                        }
                      })
                      fetchPackOrders(numberPosting);
                    }}
                  />
                )}

                {activeTab === 'awaiting-deliver' && (
                  <ButtonBasic
                    grey
                    size="32px"
                    text={'Распечатать'}
                    width="fit-content"
                    disabled={checkedProducts?.length < 1}
                    onClick={(e) => {
                      // onPostingLabels();
                      const numberPosting = checkedProducts.map(el => {
                        return {
                          api_id: el?.api_id,
                          id: el?.['Номер отправления'][0],
                          mp_id: el.mp_id,
                          campaign_id: el.campaign_id
                        }
                      })
                      fetchLabels(numberPosting);

                    }}
                  />
                )}
              </div>
            </>}
        />
      </div>
    </>
  );
};

export { OrderManagement };
